import { createAsyncThunk } from "@reduxjs/toolkit";
import { WidgetNormalizedCostVisualization } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";

import { setWidgetSetup } from "@/store/dashboards/dashboardsSlice";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";

export const normalizedCostWidgetVisualizationChangeThunk = createAsyncThunk(
  "dashboards/normalizedCostWidgetVisualizationChange",
  async (
    visualization: WidgetNormalizedCostVisualization,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const existingSetup = normalizedCostWidgetSetupSelector(state);

    if (!existingSetup) {
      return;
    }

    dispatch(
      setWidgetSetup({
        ...existingSetup,
        visualization: {
          ...existingSetup.visualization,
          ...visualization,
        },
      }),
    );
  },
);
